<template>
    <FilterPage
        title="Réseaux d'appartenance"
        v-on="$listeners"
        @reset="handleReset"
    >
        <b-form-checkbox-group
            class="search-checkboxes search-checkboxes--gray"
            v-model="value.networks"
            stacked
            @change="handleChanged"
        >
            <ul class="list-group list-group-flush">
                <template v-for="network in criterias.networks">
                    <li class="list-group-item search-checkboxes__item" style="cursor: default">
                        <div class="search-checkboxes__item-content w-100">
                            <div class="row align-items-center mx-n2">
                                <div class="col px-2">
                                    <b-form-checkbox
                                        class="search-checkboxes__checkbox"
                                        :value="network.id"
                                        :key="network.id"
                                        name="networks"
                                    >
                                        {{ network.name }}
                                    </b-form-checkbox>
                                </div>
                                <div class="col-auto px-2">
                                    <a class="small text-nowrap" target="_blank" :href="network.url">
                                        en savoir +
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </b-form-checkbox-group>
    </FilterPage>
</template>

<script>
import {BFormCheckbox, BFormCheckboxGroup} from 'bootstrap-vue';
import FilterPage from '../../../FilterPage';
import CheckboxesCriteria from "../../criterias/Checkboxes";

export default {
        components: {
            FilterPage,
            CheckboxesCriteria,
            BFormCheckbox,
            BFormCheckboxGroup,
        },
        props: {
            value: Object,
            criterias: Object,
        },
        computed: {
            checkboxesOptions() {
                return this.criterias.networks;
            },
        },
        methods: {
            handleChanged() {
                this.$emit('input', { ...this.value });
            },
            handleReset() {
                this.$emit('input', {
                    ...this.value,
                    networks: []
                });
            },
        },
    }
</script>
